module.exports = __webpack_public_path__ + "img/hainanHospital.b8a8dec7.png";